import { UNLICENSED } from '@jira/platform__application-editions/src/edition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const useShowCustomers = (): boolean => {
	const { hasCustomerServiceAccess } = useApplicationPermissions();
	const { customerService } = useAppEditions();

	if (!fg('berry-6285-customers-l1') || customerService === UNLICENSED) {
		return false;
	}

	return hasCustomerServiceAccess;
};
